import { ColumnsType, InfiniteTable } from '@/components/_common';
import EyeIcon from '@/components/_common/EyeIcon';
import { useWorkOrderAuditComplements } from '@/core/domain/workorder/AuditData/AuditData.hooks';
import {
  WorkOrderAuditDataComplementsRequest,
  WorkOrderAuditDataComplementsResponse,
} from '@/core/domain/workorder/AuditData/AuditData.types';
import formatterPrice from '@/utils/number/formatterPrice';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Card } from 'antd';
import moment from 'moment';

interface Props {
  queryParams?: WorkOrderAuditDataComplementsRequest;
}

export default function AuditComplementsTable({ queryParams }: Props) {
  const workOrderAuditComplements = useWorkOrderAuditComplements({
    ...queryParams,
  });
  const workOrderAuditComplementsData = flatInfiniteData(
    workOrderAuditComplements.data,
  );

  const columns: ColumnsType<WorkOrderAuditDataComplementsResponse> = [
    {
      title: 'Empresa',
      dataIndex: 'companyName',
      key: 'companyName',
    },
    {
      title: 'Orçamento',
      dataIndex: 'complementNumber',
      key: 'complementNumber',
    },
    {
      title: 'Cliente',
      dataIndex: 'customerName',
      key: 'customerName',
      render: (name) => name || '-',
    },
    {
      title: 'Data',
      dataIndex: 'closingDate',
      key: 'closingDate',
      render: (date) => (date ? moment(date).format('DD/MM/YYYY HH:mm') : '-'),
    },
    {
      title: 'Valor',
      dataIndex: 'totalValue',
      key: 'totalValue',
      align: 'right',
      render: (value) => formatterPrice(value),
    },
    {
      title: 'Visualizar',
      key: 'visualizar',
      align: 'center',
      width: 100,
      render: (_, row) => (
        <EyeIcon
          redirect={`/app/movements/workOrders/${row?.workOrderId}/complements/${row?.complementId}/generalInfo`}
          target="_blank"
          disabled={!row?.complementId || !row?.workOrderId}
        />
      ),
    },
  ];

  return (
    <Card type="inner" style={{ borderRadius: 10 }}>
      <InfiniteTable
        columns={columns}
        dataSource={workOrderAuditComplementsData}
        loading={workOrderAuditComplements.isFetching}
        scroll={{ x: true }}
        fetchNextPage={workOrderAuditComplements.fetchNextPage}
        hasNextPage={workOrderAuditComplements.hasNextPage}
      />
    </Card>
  );
}
